module.exports = __webpack_public_path__ + "img/NoData.e93a581f.jpg";